import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import IconButton from '@material-ui/core/IconButton'
import onClickOutside from 'react-onclickoutside'
import { toggleDrawer, closeDrawer } from '../../actions/view'
import { deleteGroup } from '../../actions/contacts/groups'
import Items from './Items'
import classNames from 'classnames'
import styles from './styles'
// import ListItem from '@material-ui/core/ListItem'
// import ListItemIcon from '@material-ui/core/ListItemIcon'
// import ListItemText from '@material-ui/core/ListItemText'
// import { AccountMinusOutline } from 'mdi-material-ui'
import { userSignOut } from 'actions/auth'
import { list } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
// import logomark from '../../logo-mark.png'
const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const mapStateToProps = state => {
  const vr_account_id =
    state.auth?.session?.idToken?.payload?.['custom:vr_account_id']
  const username = state.auth?.session?.idToken?.payload?.['cognito:username']

  return {
    drawerOpen: state.view.drawerOpen,
    permissions:
      state.data?.screenpermissions?.[
        `screenpermissions-${username}-${vr_account_id}`
      ]?.permissions,
    username,
    vr_account_id,
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      toggleDrawer,
      closeDrawer,
      deleteGroup,
      userSignOut,
      list,
    },
    dispatch,
  )
}

// const urlParams = new URLSearchParams(window.location.search)
// const jwtToken = urlParams.get('jwtToken')

class TemporaryDrawer extends Component {
  state = { loading: true }

  componentDidMount() {
    this.props
      .list('screenpermissions', null, `${DATA_API_URL}/screenpermissions`)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }))
  }

  handleClickOutside = () => {
    if (this.props.drawerOpen) {
      this.props.closeDrawer()
    }
  }

  signOut = () => {
    jwtToken
      ? window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage('signout')
      : this.props.userSignOut()
  }

  render() {
    const {
      classes,
      drawerOpen,
      closeDrawer,
      username,
      vr_account_id,
      unreadNotificationCount,
    } = this.props

    return this.state.loading ? null : (
      <Drawer
        // style={jwtToken ? { display: 'none' } : null}
        variant="permanent"
        anchor="left"
        open={drawerOpen}
        onClose={closeDrawer}
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose,
          ),
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={closeDrawer}>
            <ChevronLeftIcon />
            {/* {logomark} */}
          </IconButton>
        </div>
        <Divider />
        <List className={classes.list}>
          <div tabIndex={0} role="button" onClick={closeDrawer}>
            <Items
              username={username}
              vr_account_id={vr_account_id}
              signOut={this.signOut}
              open={drawerOpen}
              unreadNotificationCount={unreadNotificationCount}
            />
          </div>
        </List>
      </Drawer>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(onClickOutside(TemporaryDrawer)))
